var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kwanzaaDetails"},[_c('img',{attrs:{"src":_vm.whyImage}}),_c('h4',[_vm._v(_vm._s(_vm.whyHeader))]),_c('p',[_vm._v(_vm._s(_vm.whyDesc))])])}
var staticRenderFns = []

export { render, staticRenderFns }